import MixpanelEvents from '../mixpanel/mixpanelEvents';

const Lang = require('lang');
const mixpanelEvents = new MixpanelEvents;
const GlobalAlerts = require('global_alerts')

'use strict';

exports.init = function WizardDataVerifyButtons() {
  const $cpfCnpj = $('#cpfCnpj_param');
  const $pais = $('#pais_param');
  const $estado = $('#estado_param');
  const $cidade = $('#cidade_param');
  const $cep = $('#cep_param');
  const $bairro = $('#bairro_param');
  const $rua = $('#rua_param');
  const $numero = $('#numero_param');
  const $complemento = $('#complemento_param');
  const $form = $('#parametros-form');

  $form.on('submit', function () {
    if ($form.valid()) {
      $('#cpfCnpj_param').val($('#cpfCnpj_param').cleanVal());
      $('#cep_param').val($('#cep_param').cleanVal());
      $('#fone_param').val($('#fone_param').cleanVal());

      const url = route('app.settings.membros-de-equipe.usuarios-empresa-logada');
      const callback = mixpanelEvents.addParamsPeople('Quantidade usuarios ativos', url);

      mixpanelEvents.addEventForm($form, callback);
    }
  });

  const foneMask = function (val) {
    return val.replace(/\D/g, '').length === 9 ? '00000-0000' : '0000-00009';
  };
  const maskOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(foneMask.apply({}, arguments), options);
    }
  };

  $cpfCnpj.rules('add', 'cnpj');
  $cpfCnpj.mask('00.000.000/0000-00');

  $('#cep_param')
    .rules('add', {
      minlength: 9,
      maxlength: 9,
    });

  $('#foneDDD_param')
    .rules('add', {
      minlength: 2,
      maxlength: 2,
      digits: true
    });

  $('#fone_param').mask(foneMask, maskOptions);
  $('#fone_param')
    .rules('add', {
      maxlength: 10,
      minlength: 9
    });

  if ($pais.length) {
    $pais.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: false,
      hideSelected: true,
      placeholder: Lang.get('js/src/financeiro/BillingData.insert_country_name'),
      searchField: 'nome',
      labelField: 'nome',
      valueField: 'nome',
      preload: true,
      load: function (query, callback) {
        const url = route('app.settings.trechos.paises', { query: query });
        $.get(url, function (data) {
          callback(data);
        });
      }
    });
  }

  if ($estado.length) {
    $estado.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: false,
      hideSelected: true,
      placeholder: Lang.get('js/src/financeiro/BillingData.uf'),
      searchField: 'sigla',
      labelField: 'sigla',
      valueField: 'sigla',
      preload: true,
      load: function (query, callback) {
        const url = route('app.settings.trechos.estados', { query: query });
        $.get(url, function (data) {
          callback(data);
        });
      }
    });
  }

  $('body').on('input paste', '#cpfCnpj_param', function(e) {
    $('#cpfCnpj_param-success').remove();
    $('.validate-cnpj').remove();
    const cnpj = $cpfCnpj.val().replace(/[.\-\/]/g, '');

    $cep.val('');
    $cidade.val('');
    $bairro.val('');
    $rua.val('');
    $numero.val('');
    $complemento.val('');

    if (cnpj.length > 13) {
      nifty.body.overlay('hide');
      nifty.body.overlay('show');
      $.post(
        route('app.settings.validate-cnpj'), {cnpj: cnpj},
        function (response) {
          if (response.success) {
            const formGroup = $cpfCnpj.parent();
            const spans = formGroup.find('#cpfCnpj_param-success');
            if (spans.length == 0) {
              formGroup.append(`<span id="cpfCnpj_param-success" class="text-success">${response.message}.</span>`);
            } else {
              spans.first().css('display', 'block').text(response.message);
            }
            const $selectizePais = $pais.selectize()[0].selectize;
            const $selectizeEstado = $estado.selectize()[0].selectize;

            $selectizePais.setValue(response.data.country);
            $selectizeEstado.setValue(response.data.uf);

            $cep.val(response.data.cep.replace(/[.\/]/g, ''));
            $bairro.val(response.data.neighborhood);
            $cidade.val(response.data.city);
            $rua.val(response.data.street);
            $numero.val(response.data.number);
            $complemento.val(response.data.complement);
            if (!window.location.pathname.includes('periodo-teste-finalizado')) {
              $('#cidade_param').next('.selectize-control').addClass('selectize-readonly');
            }
          } else {
            const formGroup = $cpfCnpj.parent();
            formGroup.addClass('has-error');
            const spans = formGroup.find('span');
            if (spans.length == 0) {
              formGroup.append(`<span id="cpfCnpj_param-error" class="help-block validate-cnpj">${response.message}</span>`);
            } else {
              spans.first().css('display', 'block').text(response.message);
            }
          }
        })
        .fail(function (error) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        })
        .always(function () {
          nifty.body.overlay('hide')
        });
    }
  });

  $pais.next('.selectize-control').addClass('selectize-readonly');

  $estado.next('.selectize-control').addClass('selectize-readonly');
  $('#cidade_param').next('.selectize-control').addClass('selectize-readonly');
};

